import { InspectionTemplateTranslationKeys } from 'intl/keys';
import { TranslationKey } from 'intl/types/translationKey';
import { InspectionTemplateStatus } from 'shared/domain/template/templateStatus';

const TEMPLATE_STATUS_LABEL_KEYS: Record<
  InspectionTemplateStatus,
  TranslationKey
> = {
  [InspectionTemplateStatus.draft]: InspectionTemplateTranslationKeys.statusDraft,
  [InspectionTemplateStatus.published]:
    InspectionTemplateTranslationKeys.statusPublished,
};

export function templateStatusLabelKey(
  status: InspectionTemplateStatus
): TranslationKey {
  return TEMPLATE_STATUS_LABEL_KEYS[status];
}
